import React, { useEffect } from 'react'
import "./Modal.css"

const Modal = (props) => {

  const { children, isVisible } = props

  const [showModal, setShowModal] = React.useState(false)
  const [fadeEffect, setFadeEffect] = React.useState('')

  const closeModal = () => {
    setFadeEffect('fade-out')
    setTimeout(() => {
      document.body.style.overflow = 'visible'
      setShowModal(false)
    }, 300)
  }

  const openModal = () => {
    document.querySelector("body").style.overflow = "hidden"
    setFadeEffect('fade-in')
    setShowModal(true)
  }

  useEffect(() => {
    if (isVisible) {
      openModal()
    } else {
      closeModal()
    }
  }, [isVisible])

  if (!showModal) return null
    
  return (
    <div className={`modal`} style={{zIndex: 1000000}}>
      <div className={`${fadeEffect} modalBody`}>
      {/* render children */}
      {children}
      </div>
    </div>
  )
}

export { Modal }